import { render } from "./DirectorioUnidad.vue?vue&type=template&id=e331272c&scoped=true"
import script from "./DirectorioUnidad.vue?vue&type=script&lang=js"
export * from "./DirectorioUnidad.vue?vue&type=script&lang=js"

import "./DirectorioUnidad.vue?vue&type=style&index=0&id=e331272c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e331272c"]])

export default __exports__